module.exports = __webpack_public_path__ + "img/transaction_active.57cce73d.svg";